<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form">
          <a-row>
            <a-col :span="12" v-if="false">
              <a-form-item label="购销合同" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'sell_contract_id',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.number }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同编号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input disabled v-decorator="['system_contract_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="合同号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同协议号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input disabled v-decorator="['contract_protocol_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="合同协议号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货运输方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'transport_way',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  allow-clear
                  option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_logistics_transport_way">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货运输工具名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['delivery_conveyance', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" allow-clear placeholder="交货运输工具名称"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="['delivery_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="交货日期"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货地" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['delivery_address', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" allow-clear placeholder="交货地" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提货日期" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="['pick_up_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="提货日期"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提货地" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['pick_up_address', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" allow-clear placeholder="提货地" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货运输方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  v-decorator="[
                    'pick_up_transport_way',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  allow-clear
                  option-filter-prop="children"
                  :filter-option="filterOption">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_logistics_transport_way">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提货运输工具名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input v-decorator="['pick_up_conveyance', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" allow-clear placeholder="提货运输工具名称" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-row>
          <a-col span="6" :offset="8">
            <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
          </a-col>
          <a-col span="10">
            <a-button @click="handleGoBack">返回</a-button>
          </a-col>
        </a-row>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { logistics_list, logistics_update } from '@/api/trade_logistics'
const fields = ['system_contract_number', 'contract_protocol_number', 'transport_way', 'delivery_conveyance', 'delivery_date',
  'delivery_address', 'pick_up_date', 'pick_up_address', 'pick_up_transport_way', 'pick_up_conveyance']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      sellContractList: [],
      data: {},
      loading: false
    }
  },
  mounted () {
    this.loadLogisticsData()
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadLogisticsData () {
      this.loading = true
      logistics_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.data.type = '' + this.data.type
            this.id = this.data.id
            this.loadEditInfo(this.data)
          }
        }).finally(() => {
          this.loading = false
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          logistics_update(values, this.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
                console.log(res, '修改成功')
              }
            })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        console.log('formData', formData)
        formData.transport_way = '' + formData.transport_way
        formData.pick_up_transport_way = '' + formData.pick_up_transport_way
        formData.type = String(formData.type)
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
